module.exports = __webpack_public_path__ + "static/media/backsplash5_lowres.4374b8c3.jpg";